import { getAvailableLendersByLenderCommissions } from '__core/shared/util/salestrekker';
import template from './assetFinanceQuotingCalculator.template.html';

export default {
  controller: class controller {
    constructor(
      $q,
      $rootScope,
      $timeout,
      $mdUtil,
      $mdMedia,
      $mdDialog,
      eventService,
      authenticationService,
      dateTimeService,
      assetFinanceService,
      helperService,
      helperPdfService,
      quickToolService,
      organizationService,
      accountService,
      lendersService,
      AssetFinance,
      assetFinanceFinanceProposalPdfService,
      Contact,
      WorkflowType,
      Workflow,
      INSTANCE
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.isAuthenticated = authenticationService.isAuthenticated();
      ctrl.hasBrokerToolsEnabled = false;

      ctrl.initialize = () => {
        ctrl.hasBrokerToolsEnabled = ctrl.isAuthenticated
          ? $rootScope.hasBrokerToolsEnabled()
          : false;

        ctrl.destroyWatch = eventService.onQuickToolAssetFinanceQuotingCalculator((params) => {
          $mdDialog
            .show({
              template,
              targetEvent: params.event,
              locals: {},
              controllerAs: '$ctrl',
              controller() {
                const ctr = this;
                ctr.activeSection = 'assetDetails';
                ctr.isReady = false;
                ctr.isViewPreparing = false;
                ctr.isDownloadPreparing = false;
                ctr.isEnterprise = $rootScope.IsEnterprise;
                ctr.currentAccount = $rootScope.CurrentAccount;
                ctr.currentOrganization = $rootScope.CurrentOrganization;
                ctr.organizationCountry = helperService.getOrganizationCountry();
                ctr.hasBrokerToolsEnabled = $rootScope.hasBrokerToolsEnabled();
                ctr.currentTimeZone = $rootScope.CurrentTimeZone();
                ctr.currentLocale = $rootScope.CurrentLocale();
                ctr.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
                ctr.currentCurrency = $rootScope.CurrentCurrency();
                ctr.allLenders = [];
                ctr.lenders = [];
                ctr.documents = [];
                ctr.contacts = [];
                ctr.availableWorkflowTypes = WorkflowType.available();
                ctr.workflow = Workflow.build({
                  type: WorkflowType.of(ctr.availableWorkflowTypes[1]?.name)
                });
                ctr.preparedFor = '';
                ctr.settlementDate = 0;
                ctr.currentAssetFinance = AssetFinance.blank();
                ctr.currentAssetFinance.financeProposal.isEdit = true;
                ctr.isFinanceProposalReady = false;

                ctr.preparedForChange = () => {
                  ctr.contacts = [];
                  const contact = Contact.blank();
                  const fullName = ctr.preparedFor.split(' ');
                  contact.person.information.firstName = fullName[0] || '';
                  contact.person.information.familyName = fullName[1] || '';
                  ctr.contacts.push(contact);
                };

                ctr.getSetSettlementDate = function (date) {
                  if (arguments.length) {
                    // eslint-disable-next-line prefer-rest-params
                    if (arguments[0] !== null) {
                      if (ctr.settlementDate === 0) {
                        ctr.settlementDateObject = '';
                      }
                      const settlementDateObject = dateTimeService.setDate(
                        date,
                        $rootScope.CurrentTimeZone(),
                        true
                      );
                      ctr.settlementDateObject = date;
                      ctr.settlementDate = moment
                        .utc(settlementDateObject)
                        .startOf('day')
                        .format('X');
                    } else {
                      ctr.settlementDateObject = date;
                      ctr.settlementDate = '';
                    }
                  }
                  if (!ctr.settlementDateObject) {
                    if (ctr.settlementDate !== 0) {
                      const settlementDateObject = dateTimeService.setDate(
                        ctr.settlementDate,
                        $rootScope.CurrentTimeZone(),
                        false
                      );
                      ctr.settlementDateObject = settlementDateObject;
                    } else {
                      ctr.settlementDateObject = '';
                    }
                  }
                  return ctr.settlementDateObject;
                };

                $q.all([
                  organizationService.readOrganization({ id: ctr.currentOrganization?.id }),
                  accountService.readAccount({ id: ctr.currentAccount.id }),
                  lendersService.getAvailable({
                    cca2: [ctr.organizationCountry?.cca2],
                    type: 'ASSET_FINANCE'
                  })
                ]).then((data) => {
                  const organization = data[0];
                  const account = data[1];
                  const lenders = data[2];
                  ctr.isBroker = authenticationService.isBroker(account.id);

                  if (lenders?.length && account?.lenderAccreditations?.length) {
                    ctr.allLenders = _.chain(lenders)
                      .sortNatural('name')
                      .sortNatural('group')
                      .value();
                    ctr.lenders = getAvailableLendersByLenderCommissions(
                      lenders,
                      organization,
                      account,
                      ctr.workflow,
                      ctr.isEnterprise,
                      ctr.currentAssetFinance?.isCommercial
                    );
                  }
                  ctr.hasAssetFinanceTools =
                    ctr.hasBrokerToolsEnabled && ctr.isBroker && ctr.lenders.length;
                  ctr.isReady = true;

                  ctr.saveQuickQuoteFinanceProposal = (editedData) => {
                    if (!_.isEmpty(editedData)) {
                      ctr.currentAssetFinance.financeProposal = angular.copy(
                        editedData.financeProposal
                      );
                      ctr.saveAssetFinance(editedData);
                    }
                  };

                  ctr.saveAssetFinance = (editedData) => {
                    const aFCD = editedData?.aFCD || '';
                    $timeout(() => {
                      eventService.changedData({ changedData: aFCD });
                    }, 1000);
                  };

                  ctr.createPdf = ({ isView, fields }) => {
                    const options = {};
                    if (fields) {
                      options.withoutFields = fields;
                    }
                    const now = moment.utc().tz(ctr.currentTimeZone).format('X');
                    const date = dateTimeService.getFormattedDate(now);
                    const orgLogo = ctr?.currentOrganization?.organization?.logo
                      ? ctr.currentOrganization.organization.logo.replace(
                          /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/gi,
                          ctr.currentOrganization.id
                        )
                      : INSTANCE.url + INSTANCE.logo;
                    quickToolService.getBase64FromImageUrl({ url: orgLogo }).then((res) => {
                      const docDefinition = {
                        pageSize: 'A4',
                        pageMargins: [40, 40, 40, 40],
                        content: [
                          {
                            table: {
                              widths: ['*'],
                              headerRows: 1,
                              body: [
                                [
                                  {
                                    width: 180,
                                    height: 30,
                                    image: res.data,
                                    margin: [5, 3, 0, 3],
                                    style: 'tableHeader'
                                  }
                                ]
                              ]
                            },
                            layout: 'noBorders'
                          },
                          {
                            text: '',
                            margin: [0, 10, 0, 0]
                          },
                          helperPdfService.createHeader({
                            title: 'FINANCE QUOTE'
                          }),
                          {
                            table: {
                              widths: ['25%', '25%', '25%', '25%'],
                              body: [
                                [
                                  {
                                    text: [
                                      { text: 'Prepared by\n', style: 'label' },
                                      {
                                        text: ctr.currentAccount.getName(),
                                        style: 'value'
                                      }
                                    ]
                                  },
                                  {
                                    text: [
                                      { text: 'Prepared for\n', style: 'label' },
                                      {
                                        text: ctr.preparedFor || '-',
                                        style: 'value'
                                      }
                                    ],
                                    colSpan: 2
                                  },
                                  '',
                                  {
                                    text: [
                                      { text: 'Prepared on\n', style: 'label' },
                                      {
                                        text: date,
                                        style: 'value'
                                      }
                                    ]
                                  }
                                ]
                              ]
                            },
                            layout: 'noBorders'
                          },
                          {
                            text: '',
                            margin: [0, 20, 0, 0]
                          },
                          assetFinanceFinanceProposalPdfService.prepareAssetFinanceFinanceProposalDetails(
                            {
                              financeProposal: ctr?.currentAssetFinance?.financeProposal,
                              options,
                              date: ctr.settlementDate,
                              isCommercial: ctr.currentAssetFinance?.isCommercial || false
                            }
                          ),
                          {
                            text: '',
                            margin: [0, 20, 0, 0]
                          },
                          helperPdfService.createHeader({
                            title: 'DISCLAIMER'
                          }),
                          {
                            text:
                              'The information provided by the calculator is intended to provide illustrative examples based on stated assumptions and your inputs. Calculations are meant as estimates only and do not represent either a quote or pre-qualification for a loan.',
                            style: ['value', 'marginTop']
                          }
                        ],
                        styles: {
                          header: {
                            fontSize: 16,
                            bold: true,
                            margin: [0, 0, 0, 0]
                          },
                          subHeader: {
                            fontSize: 11,
                            margin: [0, 0, 0, 0]
                          },
                          subSubHeader: {
                            fontSize: 10,
                            margin: [0, 2, 0, 0]
                          },
                          prepared: {
                            fontSize: 10,
                            alignment: 'right',
                            margin: [0, 6, 5, 0]
                          },
                          marginTop: {
                            margin: [0, 7, 0, 0]
                          },
                          marginBottom: {
                            margin: [0, 0, 7, 0]
                          },
                          tableFontSize: {
                            fontSize: 10
                          },
                          tableHeader: {
                            fillColor: '#eee'
                          },
                          tableMarginTop: {
                            margin: [0, 10, 0, 0]
                          },
                          tableCellMarginTop: {
                            margin: [0, 2, 0, 0]
                          },
                          tableCellMarginLeftTopBottom: {
                            margin: [4, 2, 0, 2]
                          },
                          tableCellMarginRightTopBottom: {
                            margin: [0, 2, 4, 2]
                          },
                          tableCellMarginTopBottom: {
                            margin: [0, 2, 0, 2]
                          },
                          tableCellLeftAlign: {
                            alignment: 'left'
                          },
                          tableCellRightAlign: {
                            alignment: 'right'
                          },
                          tableCellCenterAlign: {
                            alignment: 'center'
                          },
                          label: { fontSize: 8, color: '#777' },
                          value: { fontSize: 10 },
                          valueXS: { fontSize: 8 },
                          valueXL: { fontSize: 12 },
                          lists: { fontSize: 10 },
                          noColor: { color: '#fff' }
                        }
                      };
                      pdfMake.tableLayouts = {
                        defaultLayout: {
                          hLineWidth(i, node) {
                            return i === node.table.headerRows ? 1 : 0.5;
                          },
                          vLineWidth() {
                            return 0.5;
                          },
                          hLineColor(i, node) {
                            return i === 0 || i === node.table.body.length ? '#333' : '#aaa';
                          },
                          vLineColor(i, node) {
                            return i === 0 || i === node.table.widths.length ? '#333' : '#aaa';
                          },
                          paddingLeft() {
                            return 0;
                          },
                          paddingRight() {
                            return 0;
                          },
                          paddingTop() {
                            return 0;
                          },
                          paddingBottom() {
                            return 0;
                          }
                        },
                        header: {
                          hLineWidth(i, node) {
                            return i === node.table.headerRows ? 0 : 2;
                          },
                          vLineWidth() {
                            return 0;
                          },
                          hLineColor(i, node) {
                            return i === node.table.body.length ? '#000' : '#fff';
                          },
                          paddingLeft() {
                            return 0;
                          },
                          paddingRight() {
                            return 0;
                          },
                          paddingTop() {
                            return 0;
                          },
                          paddingBottom() {
                            return 0;
                          }
                        },
                        subHeader: {
                          hLineWidth(i, node) {
                            return i === node.table.headerRows ? 0 : 0.5;
                          },
                          vLineWidth() {
                            return 0;
                          },
                          hLineColor(i, node) {
                            return i === node.table.body.length ? '#999' : '#fff';
                          },
                          paddingLeft() {
                            return 0;
                          },
                          paddingRight() {
                            return 0;
                          },
                          paddingTop() {
                            return 2;
                          },
                          paddingBottom() {
                            return 2;
                          }
                        },
                        noBorders: {
                          hLineWidth() {
                            return 0;
                          },
                          vLineWidth() {
                            return 0;
                          },
                          hLineColor() {
                            return 0;
                          },
                          paddingLeft() {
                            return 5;
                          },
                          paddingRight() {
                            return 5;
                          },
                          paddingTop() {
                            return 3;
                          },
                          paddingBottom() {
                            return 3;
                          }
                        },
                        noBordersNoPadding: {
                          hLineWidth() {
                            return 0;
                          },
                          vLineWidth() {
                            return 0;
                          },
                          hLineColor() {
                            return 0;
                          },
                          paddingLeft() {
                            return 0;
                          },
                          paddingRight() {
                            return 0;
                          },
                          paddingTop() {
                            return 0;
                          },
                          paddingBottom() {
                            return 0;
                          }
                        }
                      };
                      if (isView) {
                        ctr.isViewPreparing = false;
                        pdfMake.createPdf(docDefinition).open();
                      } else {
                        ctr.isDownloadPreparing = false;
                        const fileName = `${moment.utc().year()}${
                          moment.utc().month() + 1
                        }${moment
                          .utc()
                          .date()} Quick tools - Commercial quoting calculator.pdf`;
                        pdfMake.createPdf(docDefinition).download(fileName);
                      }
                    });
                  };
                });
                ctr.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then(() => {
              //
            });
        });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
